module.exports = __webpack_public_path__ + "img/gold.af1ea075.svg";